import {MainApi} from "./MainApi";

export class TestResultApi {
    static baseUrl = `${MainApi.urlPrefix}/test-result`;

    static getKpassTestResult = (executedInfoIdx: number, token: string) => () =>
        MainApi.api.get(`${TestResultApi.baseUrl}/${executedInfoIdx}/${token}`);
}